/*
 * @Author: 陈大仙人
 * @Date: 2020-06-28 11:24:20
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2025-10-23 17:31:39
 * @FilePath: /akx-factory-main/src/config.js
 */
module.exports = {
	baseURL: (function () {
		if (process.env.NODE_ENV === 'development') {
			return 'https://dc-dev.boogcloud.com/datacloud/bubu';
		} else if (process.env.NODE_ENV === 'production') {
			return 'https://dc.boogcloud.com/datacloud/bubu';
		}
	})(),
};
